import React, { useState, useEffect, useMemo, useCallback } from "react"
import "./BookAppointments.scss"
import InputField from "../../../components/InputField"
import Button from "../../../components/Button"
import DatePicker from "react-datepicker"
import Toast from "../../../components/Toast"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import { useHistory } from "react-router"
import { useLocation } from "react-router"
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import {
  getPatientDetail,
  getAppointmentById,
  getPatientInformation,
  getAvailabilitySlots,
  bookAppointment,
  getAllConsultants,
  getServiceBasedOnCategory,
  getAppointmentsByQuery,
  getAllStaffs,
  getCenterDetail,
  bookSpecialAppointment,
  getAvailabilityDetails,
} from "../../../core/services/api"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { fetchRooms } from "../../../core/services/api/bedManagementService"
import PedigreeView from "../../PatientClinicalView/components/GeneticCounsellor/components/PedigreeView/PedigreeView"
import PermissionUtils from "../../../core/store/utils/PermissionUtils"
import drawerAction from "../../../core/store/actions/drawerAction"
import { MocUserRole } from "../../../core/services/models/Enums"
import debounce from 'lodash/debounce'
import { calculateAge } from "core/utils/date"
import { getDisabledCenters } from "core/services/api/migrationService"


function BookAppointments() {
  //Css Changes for Select
  const customSelectStyles = {
    // Add your custom styles here
    // For example:
    container: (provided: any) => ({
      ...provided,
      border: '1px solid #ccd0e7',
      borderRadius: '10px',
      boxShadow: '0px 2px 6px rgba(141, 155, 184, 0.25)',

    }),
    control: (provided: any) => ({
      ...provided,
      border: 'none',
      borderRadius: '10px',
    }),
    // More style definitions...
  };

  const customSelectStylesTest = {
    // Add your custom styles here
    // For example:
    container: (provided: any) => ({
      ...provided,
      border: '1px solid #ccd0e7',
      borderRadius: '10px',
      boxShadow: '0px 2px 6px rgba(141, 155, 184, 0.25)',

    }),
    control: (provided: any) => ({
      ...provided,
      border: 'none',
      borderRadius: '10px',
    }),
    // More style definitions...
  };

  //Css Changes for Select
  const customSelectStylesAppointment = {
    // Add your custom styles here
    // For example:
    container: (provided: any) => ({
      ...provided,
      border: '1px solid #ccd0e7',
      borderRadius: '10px',
      boxShadow: '0px 2px 6px rgba(141, 155, 184, 0.25)',

    }),
    control: (provided: any) => ({
      ...provided,
      border: 'none',
      borderRadius: '10px',
    }),
    // More style definitions...
  };

  const appointmentTypes: string[] = [
    "New Patient Appointment",
    "Follow up appointment",
    "Walk in appointment",
  ]

  //Dropdown values
  const timeofDay: string[] = ["MORNING", "AFTERNOON", "EVENING"]

  const preferredtime: string[] = ["Morning", "Afternoon"]

  const element = document.getElementById("appointment-wrapper")

  const [appointmentDetails, setappointmentDetails] = useState<any>({
    followUp: "",
    serviceCategory: "",
    serviceIds: [],
    primaryConsultant: "",
    docCategory: "",
    appointmentType: "",
    documents: [],
    comments: "",
  })
  const [displayToast, toggleDisplayToast] = useState<any>()
  //Radio for OPD ,IPD and HomeCare
  const [selectedRadioBtn, setSelectedRadioBtn] = useState("OPD")
  const [serviceBasedCategory, setserviceBasedCategory] = useState<any>([])
  //Date
  const [startDate, setStartDate] = useState<any>(new Date())

  // home care
  const [homecareConsultants, setHomeCareConsultants] = useState<any>()
  const [displayConsultant, setDisplayConsultant] = useState<any>()
  //Get all Consultants list
  const [consultantDetails, setallConsultantDetails] = useState<any>([])
  const [consultantId, setconsultantId] = useState<any>("")
  const [fieldsSelected, setFieldsSelected] = useState<boolean>(false)
  //preferred rooms & bed
  const [allRooms, updateAllRooms] = useState<any>([])
  const [preferedRoom, updatePreferedRoom] = useState<any>()
  const [preferedBed, updatePreferedBed] = useState<any>()
  const [selectedBedSlotTime, updateSelectedBedSlotTime] = useState<any>()
  const [isCheckedSpecial, setIsCheckedSpecial] = useState<any>(false)
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const [avaialbilitySlotsResult, setAvaialbilitySlotsResult] = useState<any>({})

  //Validation popups
  const [isDead, setIsDead] = useState<boolean>(false)
  const [isInactive, setIsInactive] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState(false)

  const [appointmentId, updateAppointmentId] = useState<any>()

  const [availmor, setAvailMor] = useState<any>()
  const [availaftr, setAvailMorAftr] = useState<any>()
  const [availmoreve, setAvailMorEve] = useState<any>()

  //Selecting Morning, evening, afternoon values and evening
  const [selectedTime, setselectedTime] = useState<any>([])

  //array of timings [9:30,9:45]
  const [timeSlot, setTimeSlot] = useState<Array<string>>([])
  const [slotDurationTime, setSlotDurationTime] = useState<any>(0)
  const [centerreq, setCenterReq] = useState<any>()

  const [patient, setPatient] = useState<any>({})
  const [ispatient, setIsPatient] = useState<any>([])

  //finally selecting the timing
  const [time, setTime] = useState<any>([])

  const [searchText, setSearchText] = useState<any>()
  const [confirmAppointmentPending, setConfirmAppointmentPending] = useState<boolean>(false)
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [isDisabledCenter, setIsDisabledCenter] = useState(false);


  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const location = useLocation()
  const dispatch = useDispatch()

  //Redirection
  const history = useHistory()

  const pageDetails = location.state
  const isRadioSelected = (value: string): boolean => selectedRadioBtn === value
  const handleRadioClick = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSelectedRadioBtn(e.currentTarget.value)
    setappointmentDetails({
      ...appointmentDetails,
      serviceCategory: [],
      serviceIds: [],
      consultantName: "",
      consultantId: ""
    })
    setSelectedServices([])
    setconsultantId("")
  }

  let sort_Order = serviceBasedCategory.sort()

  function fetchAppointmentById(appId: any) {
    const source = new URLSearchParams(location.search).get("source")

    getAppointmentById(appId)
      .then((res) => {
        setconsultantId(res.primaryConsultantId)

        const temp = Object.assign({}, appointmentDetails)
        temp["appointmentType"] =
          res.patientAppointmentType === "FOLLOW_UP"
            ? "Follow up appointment"
            : res.patientAppointmentType === "NEW"
              ? "New Patient Appointment"
              : res.patientAppointmentType === "WALK_IN"
                ? "Walk in appointment"
                : ""

        temp["serviceCategory"] =
          source && source === "convertToIPD" ? null : res?.serviceName
        temp["primaryConsultant"] = res?.primaryConsultantName
        setappointmentDetails(temp)
        setSelectedRadioBtn(
          source && source === "convertToIPD" ? "IPD" : res?.appointmentType
        )
      })
      .catch((err) => {
        console.error("err", err)
      })
  }

  function populatePatientDetail(patientid: any) {
    getPatientDetail(patientid)
      .then((res) => {
        setPatient(res)
        fetchUpcomingAppsOfPatient(patientid)
      })
      .catch((err) => {
        console.error("get patient detail error", err)
      })
  }

  //selecting date
  let modifiedDate = moment(startDate).local().format("yyyy-MM-DD")

  //getting current time
  var Time = moment()
  var currentTime = moment(Time).format("HH:mm")
  var todayDate = moment(Time).local().format("yyyy-MM-DD")

  const handleTimeClick = (e: string): void => {
    const temp: any = [].concat(time)
    if (temp && temp?.includes(e)) {
      temp.splice(temp.indexOf(e), 1)
    } else {
      temp.push(e)
    }
    setTime(temp)
  }

  const memoizedValues = useMemo(() => {
    return {
      consultantId,
      centerId: userDetail?.currentCenter?.centerId,
      modifiedDate,
    };
  }, [consultantId, userDetail?.currentCenter?.centerId, modifiedDate]);

  const service = sort_Order?.map((ele: any) => {
    return { label: ele?.name, value: ele?.id }
  })
  const [selectedServices, setSelectedServices] = useState<any>([])
  const appointmentType = appointmentTypes.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const consultants = displayConsultant?.map((each: any) => {
    return {
      label: each?.name,
      value: each?.id,
    }
  })
  const room = allRooms?.map((each: any) => {
    return { label: each?.name, value: each?.id }
  })
  const bed = preferedRoom?.bedDetails?.map((each: any) => {
    return { label: each?.name, value: each?.id }
  })
  const pretime = preferredtime.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const timeSlots = timeofDay.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const patientInfo = (searchText: string) => {
    if (!searchText) {
      setPatient({})
      return
    }
    if (searchText) {
      getPatientInformation(searchText, userDetail?.currentCenter?.centerId)
        .then((res: any) => {
          const { data }: any = res
          if (data?.length > 0) {
            const response = data[0]
            setPatient(response)
            if (response?.id) fetchUpcomingAppsOfPatient(response?.id)
            validateStatus(response)
            setIsOpen(false)
          }
        })
        .catch((err: any) => {
          console.error("err", err)
          toggleDisplayToast({
            text: "Please enter correct details",
            type: "error",
          })
        })
    }
  }

  function validateStatus(patientInfo: any) {
    if (patientInfo) {
      if (patientInfo?.survivalStatus?.toLowerCase() === "deceased" || patientInfo?.survivalStatus?.toLowerCase() === "dead") {
        setIsDead(true)
      } else if (
        patientInfo?.survivalStatus?.toLowerCase() === "alive" &&
        patientInfo?.accountStatus?.toLowerCase() !== "active"
      ) {
        setIsInactive(true)
      }
    }
  }

  const setPatientDetails = (selectedPatient: any) => {
    setSearchText(selectedPatient?.isVIP ? selectedPatient?.mocId : selectedPatient?.name);
    fetchUpcomingAppsOfPatient(selectedPatient?.id);
    validateStatus(selectedPatient);
    setPatient(selectedPatient);
    setIsOpen(false);
  }

  function fetchUpcomingAppsOfPatient(patId: any) {
    getAppointmentsByQuery(`patientId=${patId}&pastOrUpcoming=UPCOMING`)
      .then((res: any) => {
        dispatch(
          drawerAction.setDrawerComponent({
            name: "BookAppointmentDrawer",
            data: { upcomingAppointments: res },
          })
        )
      })
      .catch((err: any) => {
        console.error("err", err)
        dispatch(
          drawerAction.setDrawerComponent({
            name: "BookAppointmentDrawer",
            data: { upcomingAppointments: [] },
          })
        )
      })
  }

  function isConsecutiveSlot(slots: any, diff: any) {
    let count = 0
    slots?.sort(function (a: any, b: any) {
      return a < b ? -1 : 1
    })
    for (var i = 1; i < slots?.length; i++) {
      const duration = moment.duration(
        moment(slots[i], "HH:mm").diff(moment(slots[i - 1], "HH:mm"))
      )
      if (duration?.asMinutes() !== diff) {
        count = count + 1
      }
    }
    return count
  }

  function confirmAppointment() {
    if (isDisabledCenter) {
      toggleDisplayToast({
        text: "Center is disabled. Appointments cannot be booked.",
        type: "error",
      })
      history.push("/calendar")
      return
    }
    //Check if the slots selected are consecutive
    let count = 0
    if (selectedRadioBtn !== "IPD") {
      if (time?.length > 0) {
        count = isConsecutiveSlot(time, slotDurationTime)
      } else {
        toggleDisplayToast({
          text: "Please enter time slots to proceed",
          type: "error",
        })
        return
      }
    }
    //POST API Call for Book Appointments
    if (count === 0) {
      let tempCons: any
      if (selectedRadioBtn === "HC") {
        tempCons = homecareConsultants?.find(
          (each: any) => each?.id === consultantId
        )
      } else if (selectedRadioBtn !== "IPD") {
        tempCons = consultantDetails?.find(
          (each: any) => each?.id === consultantId
        )
      }

      var appointments: any = {
        patientId: patient?.id,
        centerId: userDetail?.currentCenter?.centerId,
        centerName: userDetail?.currentCenter?.centerName,
        appointmentType: selectedRadioBtn,
        patientAppointmentType:
          appointmentDetails.appointmentType === "Follow up appointment"
            ? "FOLLOW_UP"
            : appointmentDetails.appointmentType === "New Patient Appointment"
              ? "NEW"
              : appointmentDetails.appointmentType === "Walk in appointment"
                ? "WALK_IN"
                : "",
        serviceName: appointmentDetails.serviceCategory,
        serviceIds: appointmentDetails.serviceIds,
        primaryConsultantId: patient?.primaryConsultantId
          ? patient?.primaryConsultantId
          : tempCons?.id,
        primaryConsultantName: patient?.primaryConsultantName
          ? patient?.primaryConsultantName
          : tempCons?.name,
        consultantId: tempCons ? tempCons?.id : "",
        consultantName: tempCons ? tempCons?.name : "",
        consultantColourCode: tempCons?.colorCoding,
        scheduleDate: moment(startDate).local().format("yyyy-MM-DD"),
        slots: time,
        documents: appointmentDetails?.documents,
        bookingDoneBy: userDetail?.name,
        comments: appointmentDetails?.comments,
        isSpecialRequest: false,
      }

      const appId = new URLSearchParams(location.search).get("appointmentId")
      const source = new URLSearchParams(location.search).get("source")
      if (appId && source !== "convertToIPD") {
        appointments["isRescheduled"] = true
      } else {
        appointments["isRescheduled"] = false
      }

      if (selectedRadioBtn === "IPD") {
        appointments["bedPreference"] = {
          roomId: preferedRoom?.id,
          bedId: preferedBed,
          time: selectedBedSlotTime,
        }
      }

      if (pageDetails) {
        appointments["patientId"] = pageDetails?.id
      }
      delete appointments["serviceName"]
      if (!confirmAppointmentPending) {
        setConfirmAppointmentPending(true)
        bookAppointment(appointments)
          .then((res) => {
            toggleDisplayToast({
              text:
                userRole === MocUserRole.PATIENT
                  ? `Appointment has been requested successfully`
                  : `Appointment has been ${appointmentId ? "updated" : "booked"
                  } successfully`,
              type: "success",
            })
            setConfirmAppointmentPending(false)
          })
          .catch((error) => {
            const patientName = patient?.id;
            const text = patientName
              ? error?.response?.data?.message
                ? error?.response?.data?.message
                : `Unable to ${appointmentId ? "update" : "book"} Appointment`
              : "No patient selected, Please select a patient to book an appointment";

            toggleDisplayToast({
              text,
              type: "error",
            });
            setConfirmAppointmentPending(false)
          })
      }
    } else {
      toggleDisplayToast({
        text: "Please select consecutive slot to proceed",
        type: "error",
      })
    }
  }

  function confirmSpecialAppointment() {
    if (isDisabledCenter) {
      toggleDisplayToast({
        text: "Center is disabled. Appointments cannot be booked.",
        type: "error",
      })
      history.push("/calendar")
      return
    }
    //Check if the slots selected are consecutive

    let count = 0
    //POST API Call for Book Appointments
    if (count === 0) {
      let tempCons: any
      if (selectedRadioBtn === "HC") {
        tempCons = homecareConsultants?.find(
          (each: any) => each?.id === consultantId
        )
      } else if (selectedRadioBtn !== "IPD") {
        tempCons = consultantDetails?.find(
          (each: any) => each?.id === consultantId
        )
      }

      var specialAppointments: any = {
        patientId: patient?.id,
        centerId: userDetail?.currentCenter?.centerId,
        centerName: userDetail?.currentCenter?.centerName,
        appointmentType: selectedRadioBtn,
        patientAppointmentType:
          appointmentDetails.appointmentType === "Follow up appointment"
            ? "FOLLOW_UP"
            : appointmentDetails.appointmentType === "New Patient Appointment"
              ? "NEW"
              : appointmentDetails.appointmentType === "Walk in appointment"
                ? "WALK_IN"
                : "",
        serviceName: appointmentDetails.serviceCategory,
        serviceIds: appointmentDetails?.serviceIds,
        primaryConsultantId: patient?.primaryConsultantId
          ? patient?.primaryConsultantId
          : tempCons?.id,
        primaryConsultantName: patient?.primaryConsultantName
          ? patient?.primaryConsultantName
          : tempCons?.name,
        consultantId: tempCons?.id,
        consultantName: tempCons?.name,
        consultantColourCode: tempCons?.colorCoding,
        scheduleDate: moment(startDate).local().format("yyyy-MM-DD"),
        documents: appointmentDetails?.documents,
        bookingDoneBy: userDetail?.name,
        comments: appointmentDetails?.comments,
        specialRequestFromTime: moment(
          appointmentDetails?.specialRequestFromTime,
          "hh:mm"
        ).format("HH:mm"),
        specialRequestToTime: moment(
          appointmentDetails?.specialRequestToTime,
          "hh:mm"
        ).format("HH:mm"),
        isSpecialRequest: true,
      }

      const appId = new URLSearchParams(location.search).get("appointmentId")
      if (appId) {
        specialAppointments["isRescheduled"] = true
      } else {
        specialAppointments["isRescheduled"] = false
      }

      if (selectedRadioBtn === "IPD") {
        specialAppointments["bedPreference"] = {
          roomId: preferedRoom?.id,
          bedId: preferedBed,
          time: selectedBedSlotTime,
        }
      }

      delete specialAppointments["serviceName"]
      bookSpecialAppointment(specialAppointments)
        .then((res) => {
          toggleDisplayToast({
            text:
              userRole === MocUserRole.PATIENT
                ? `Appointment has been requested successfully`
                : `Appointment has been ${appointmentId ? "updated" : "booked"
                } successfully`,
            type: "success",
          })
        })
        .catch((error) => {
          toggleDisplayToast({
            text: error?.response?.data?.message
              ? error?.response?.data?.message
              : `Unable to ${appointmentId ? "update" : "book"} Appointment`,
            type: "error",
          })
        })
    } else {
      toggleDisplayToast({
        text: "Please select consecutive slot to proceed",
        type: "error",
      })
    }
  }

  function renderEachTSlot(key: any) {
    const isActive = time?.includes(key)
    return (
      <div
        className="timeSlot"
        style={{
          backgroundColor: isActive ? "#024cf2" : "white",
          color: isActive ? "white" : "black",
        }}
        onClick={() => handleTimeClick(key)}
      >
        {moment(key, "HH:mm").format("hh:mm A")}
      </div>
    )
  }

  const debouncedApiCall = useCallback(
    debounce((searchTextValue, centerId) => {
      getPatientInformation(searchTextValue, centerId)
        .then((res: any) => {
          const { data }: any = res;
          setIsPatient(data)
        })
        .catch((err: any) => {
          console.error("err", err);
          toggleDisplayToast({
            text: "Please enter correct details",
            type: "error",
          });
        });
    }, 300),
    []
  );

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (selectedOptionIndex >= 0) {
        const selectedOption = ispatient[selectedOptionIndex];
        setIsOpen(false);
        setPatientDetails(selectedOption)
      } else {
        const trimmedSearchText = searchText?.trim();
        setSearchText(trimmedSearchText);
        patientInfo(trimmedSearchText);
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setSelectedOptionIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : ispatient.length - 1
      );
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      setSelectedOptionIndex((prevIndex) =>
        prevIndex < ispatient.length - 1 ? prevIndex + 1 : -1
      );
    }
  };

  const handleChange = (e: any) => {
    setSearchText(e.target.value?.trimStart());
    setIsOpen(true);
    setSelectedOptionIndex(-1);
  };

  const handleFocus = () => {
    setIsOpen(true);
  };

  const handleBlur = (event: any) => {
    // Delay the blur event to check if it was caused by a click inside the options
    setTimeout(() => {
      if (event.currentTarget && !event.currentTarget.contains(document.activeElement)) {
        // Check if the active element is not inside the input field
        if (selectedOptionIndex >= 0) {
          const selectedOption = ispatient[selectedOptionIndex];
          const patientId = selectedOption?.isVIP ? selectedOption?.mocId : selectedOption?.name;
          patientInfo(patientId);
        } else {
          const trimmedSearchText = searchText?.trim();
          setSearchText(trimmedSearchText);
          patientInfo(trimmedSearchText);
        }
        setIsOpen(false);
      }
    }, 0);
  };

  function renderSection1() {
    return (
      <section>
        <div
          className="section-wrapper"
          style={{ paddingTop: "30px", paddingLeft: "25px" }}
        >
          <div className="section-Heading-main">Summary of Appointment</div>
          {userRole && userRole === MocUserRole.PATIENT ? null : (
            <div className="patient-search">
              <div className="section-label">
                Enter Patient Name/Phone Number/ID:
              </div>
              <div className="mobile-number-field">
                <InputField
                  onKeyDown={handleKeyDown}
                  handleChange={handleChange}
                  value={searchText}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder="Search Patient"
                />

                {isOpen && (
                  <div className="options">
                    {ispatient
                      .map((ele: any, index: any) => {
                        const isSelected = index === selectedOptionIndex;

                        return (
                          <div key={ele?.id}>
                            <div
                              className={`names ${isSelected ? 'selected' : ''}`}
                              onClick={() => {
                                setSelectedOptionIndex(index)
                                setPatientDetails(ele)
                              }}
                            >
                              {!ele?.isVIP && `${ele?.name} - `} {ele?.mocId}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
              <div>
                <div
                  className="go-button"
                  onClick={() => patientInfo(searchText)}
                >
                  <Button text="Go" id="go"></Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    )
  }

  function renderSection2() {
    return (
      <section className="section2">
        <div className="section-wrapper">
          <div className="table-main">
            <div className="col-3 col-md-4 col-lg-4 p-0">
              <div className="tablePatient">
                <table>
                  <tbody>
                    <tr>
                      <th>Name:</th>
                      <td>
                        {pageDetails
                          ? pageDetails?.name
                          : patient && Object.keys(patient)?.length > 0
                            ? PermissionUtils.displayPatientName(
                              userRole,
                              patient,
                              true,
                              null,
                              null
                            )
                            : null}
                      </td>
                    </tr>
                    <tr>
                      <th>Gender:</th>
                      <td>
                        {pageDetails ? pageDetails?.gender : patient?.gender}
                      </td>
                    </tr>
                    <tr>
                      <th>Age:</th>
                      <td>{pageDetails ? calculateAge(pageDetails?.dob) : patient?.dob ? calculateAge(patient?.dob) : ""}</td>
                    </tr>
                    <tr>
                      <th>Dob:</th>
                      <td>{pageDetails?.dob ? moment(pageDetails?.dob)?.format("DD-MM-YYYY") : patient?.dob ? moment(patient?.dob)?.format("DD-MM-YYYY") : ""}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-3 col-md-5 col-lg-5 p-0">
              <div className="tablePatient">
                <table>
                  <tbody>
                    <tr>
                      <th>Category:</th>
                      <td>
                        {pageDetails
                          ? pageDetails?.category
                          : patient?.category}
                      </td>
                    </tr>
                    <tr>
                      <th>Registration Number:</th>
                      <td>
                        {pageDetails ? pageDetails.mocId : patient?.mocId}
                      </td>
                    </tr>

                    <tr>
                      <th style={{ verticalAlign: "top" }}>Address:</th>

                      <td className="address-field" style={{ width: "200px" }}>
                        <span style={{ wordBreak: "break-all" }}>
                          {pageDetails
                            ? pageDetails?.adressInfo?.addressLine1 === '-' ? '' : pageDetails?.adressInfo?.addressLine1
                            : patient?.addressInfo?.addressLine1 === '-' ? '' : patient?.addressInfo?.addressLine1}
                          {pageDetails
                            ? pageDetails?.addressInfo?.addressLine2 === '-' ? '' : pageDetails?.addressInfo?.addressLine2
                            : patient?.addressInfo?.addressLine2 === '-' ? '' : patient?.addressInfo?.addressLine2}{" "}
                          {pageDetails
                            ? pageDetails?.addressInfo?.city === '-' ? '' : pageDetails?.addressInfo?.city
                            : patient?.addressInfo?.city === '-' ? '' : patient?.addressInfo?.city}{" "}
                          {pageDetails
                            ? pageDetails?.addressInfo?.state === '-' ? '' : pageDetails?.addressInfo?.state
                            : patient?.addressInfo?.state === '-' ? '' : patient?.addressInfo?.state}{" "}
                          {pageDetails
                            ? pageDetails?.addressInfo?.pincode === '-' ? '' : pageDetails?.addressInfo?.pincode
                            : patient?.addressInfo?.pincode === '-' ? '' : patient?.addressInfo?.pincode}{" "}
                          {pageDetails
                            ? pageDetails?.addressInfo?.country === '-' ? '' : pageDetails?.addressInfo?.country
                            : patient?.addressInfo?.country === '-' ? '' : patient?.addressInfo?.country}
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <th></th>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  function renderSection3() {
    return (
      <section className="section3" style={{ paddingBottom: "30px" }}>
        <div className="section-wrapper">
          <div className="section-Heading">*Select Services</div>
          <div>
            {/* Input checkbox */}
            <div className="cont-bg">
              <div className="cont-main">
                <div
                  className="cont-checkbox"
                  style={{
                    backgroundColor: "#FFF2CC",
                    borderColor: "#FFBF00",
                    borderStyle: "solid",
                    borderWidth: "1px",
                  }}
                >
                  <input
                    type="radio"
                    name="myRadio"
                    id="myRadio-1"
                    value="OPD"
                    checked={isRadioSelected("OPD")}
                    onChange={handleRadioClick}
                  />
                  <label htmlFor="myRadio-1">
                    <img src="assets/images/opd.svg" alt="" />
                    <span className="cover-checkbox">
                      <svg viewBox="0 0 12 10">
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                      </svg>
                    </span>
                    <div className="info">OPD Consultation</div>
                  </label>
                </div>
                <div
                  className="cont-checkbox"
                  style={{
                    backgroundColor: "#DEF3CE",
                    borderColor: "#19B400",
                    borderStyle: "solid",
                    borderWidth: "1px",
                  }}
                >
                  <input
                    type="radio"
                    name="myRadio"
                    id="myRadio-2"
                    value="IPD"
                    checked={isRadioSelected("IPD")}
                    onChange={handleRadioClick}
                  />
                  <label htmlFor="myRadio-2">
                    <img
                      src="assets/images/ipd.svg"
                      alt=""
                      className="imageServices"
                    />
                    <span className="cover-checkbox">
                      <svg viewBox="0 0 12 10">
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                      </svg>
                    </span>
                    <div className="info">IPD Consultation</div>
                  </label>
                </div>

                <div
                  className="cont-checkbox"
                  style={{
                    backgroundColor: "#CCFCFF",
                    borderColor: "#00B9C533",
                    borderStyle: "solid",
                    borderWidth: "1px",
                  }}
                >
                  <input
                    type="radio"
                    name="myRadio"
                    id="myRadio-3"
                    value="HC"
                    checked={isRadioSelected("HC")}
                    onChange={handleRadioClick}
                  />
                  <label htmlFor="myRadio-3">
                    <img src="assets/images/homeCare.svg" alt="" />
                    <span className="cover-checkbox">
                      <svg viewBox="0 0 12 10">
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                      </svg>
                    </span>
                    <div className="info">Home Care</div>
                  </label>
                </div>
              </div>
            </div>

            {/* Input Checkbox ends here */}
            <div className="consult-dropdown">
              <div className="col-md-6 custom-bookAppointment-dropdown">
                {selectedRadioBtn === "OPD" ? (
                  <Select
                    styles={customSelectStyles}
                    options={service}
                    value={selectedServices}
                    isMulti={false}
                    onChange={(option: any) => {
                      let temp: any
                      let newTemp: any
                      let tempObj: any = []
                      if (Array.isArray(option)) {
                        temp = option.map((e: any) => e.label)
                        newTemp = option.map((e: any) => e.value)
                      } else {
                        temp = [option.label]
                        newTemp = [option.value]
                      }
                      setappointmentDetails({
                        ...appointmentDetails,
                        serviceCategory: temp,
                        serviceIds: newTemp
                      })
                      tempObj = temp?.map((ele: any, i: any) => {
                        return { label: ele, value: newTemp[i] }
                      })
                      setSelectedServices(tempObj)
                    }}
                    isSearchable={true}
                    placeholder="Select Service"
                  />
                ) : (
                  <Select
                    options={service}
                    styles={customSelectStyles}
                    value={selectedServices}
                    onFocus={() => {
                      if (
                        selectedRadioBtn === "IPD" ||
                        selectedRadioBtn === "HC"
                      ) {
                        setIsMenuOpen(true)
                      }
                    }}
                    onBlur={() => {
                      if (
                        selectedRadioBtn === "IPD" ||
                        selectedRadioBtn === "HC"
                      ) {
                        setIsMenuOpen(false)
                      }
                    }}
                    menuIsOpen={isMenuOpen}
                    isMulti={
                      selectedRadioBtn === "IPD" || selectedRadioBtn === "HC"
                        ? true
                        : false
                    }
                    onChange={(option: any) => {
                      let temp: any
                      let newTemp: any
                      let tempObj: any = []
                      if (Array.isArray(option)) {
                        temp = option.map((e: any) => e.label)
                        newTemp = option.map((e: any) => e.value)
                      } else {
                        temp = [option.label]
                        newTemp = [option.value]
                      }
                      setappointmentDetails({
                        ...appointmentDetails,
                        serviceCategory: temp,
                        serviceIds: newTemp
                      })
                      tempObj = temp?.map((ele: any, i: any) => {
                        return { label: ele, value: newTemp[i] }
                      })
                      setSelectedServices(tempObj)
                    }}
                    isSearchable={true}
                    placeholder="Select Service"
                  />
                )}
              </div>

              <div className="col-md-6 custom-bookAppointment-dropdown">
                {selectedRadioBtn !== "IPD" && (
                  <Select
                    styles={customSelectStyles}
                    options={consultants}
                    value={consultants?.find((consultant: any) => consultant?.value === consultantId) || null}
                    onChange={(option: any) => {
                      setappointmentDetails({
                        ...appointmentDetails,
                        consultantId: option?.value,
                        consultantName: option?.label
                      })
                      setconsultantId(option?.value)
                    }}
                    isSearchable={true}
                    placeholder={
                      selectedRadioBtn === "OPD"
                        ? "Select Consultant"
                        : " Select Home Care"
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  function renderTodaySlots() {
    const filteredVals = timeSlot.filter((time: any) => time > currentTime)
    return filteredVals?.length > 0 ? (
      filteredVals?.map((key: any) => renderEachTSlot(key))
    ) : (
      <div
        style={{
          fontSize: "18px",
          color: "red",
          fontWeight: "800",
          marginTop: "5px",
          letterSpacing: '0.85px'
        }}
      >
        No Slots Available
      </div>
    )
  }

  function renderSection4() {
    return (
      <section className="section-4-wrapper">
        <div className="doctor-details">
          <div className="row doctor-details-item">
            <div className="col-md-2">
              <div className="doctor-details-text">Location:</div>
            </div>
            <div className="col-md-4">
              <div className="doctor-details-value">
                {patient?.centers &&
                  patient?.centers[0] &&
                  patient?.centers[0]?.centerName
                  ? patient?.centers[0]?.centerName
                  : ""}
              </div>
            </div>
          </div>
          <div className="row doctor-details-item">
            <div className="col-md-2">
              <div className="doctor-details-text">*Primary Consultant :</div>
            </div>
            <div className="col-md-4">
              <div className="doctor-details-value">
                {pageDetails ? pageDetails.primaryConsultantName : patient?.primaryConsultantName}
              </div>
            </div>
          </div>
          <div className="row doctor-details-item">
            <div className="col-md-2">
              <div className="doctor-details-text">Select Date:</div>
            </div>
            <div className="col-md-2">
              <label className="date-icon" style={{ display: "flex" }}>
                &nbsp;&nbsp;&nbsp;
                <DatePicker
                  selected={startDate}
                  onChange={(date: Date, e) => {
                    e?.preventDefault();
                    setStartDate(date);
                    setOpenCalendar(false);
                  }}
                  popperPlacement="bottom-start"
                  minDate={
                    userRole === MocUserRole.PATIENT &&
                      selectedRadioBtn === "IPD"
                      ? moment().add(centerreq, "d").toDate()
                      : moment().toDate()
                  }
                  dateFormat="dd MMMM, EEEE"
                  onKeyDown={(e) => {
                    e.preventDefault()
                  }}
                  onFocus={() => setOpenCalendar(true)}
                  open={openCalendar}
                  onClickOutside={() => setOpenCalendar(false)}
                />

              </label>
            </div>
          </div>
          <div className="row doctor-details-item">
            <div className="col-md-2">
              <div className="doctor-details-text">*Appointment Type :</div>
            </div>
            <div className="col-md-4">
              <Select
                styles={customSelectStylesAppointment}
                options={appointmentType}
                defaultValue={appointmentType}
                onChange={(option: any) => {
                  setappointmentDetails({
                    ...appointmentDetails,
                    appointmentType: option?.value,
                  })
                }}
                isSearchable={true}
                placeholder="Appointment Type"
                value={appointmentType.filter(
                  ({ label }: any) =>
                    label === appointmentDetails.appointmentType
                )}
              />
            </div>
          </div>
          {selectedRadioBtn === "OPD" && <div className="row doctor-details-item ">
            <div className="col-md-2">
              <div className="doctor-details-text">Special Request:</div>
            </div>
            <div className="col-md-4 m-2">
              <div onClick={() => setIsCheckedSpecial((prev: any) => !prev)}>


                {isCheckedSpecial ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />
                }
              </div>
            </div>
          </div>
          }

          {isCheckedSpecial &&
            <><div className="row doctor-details-item ">
              <div className="col-md-2">
                <div className="doctor-details-text">Special Request From Time :</div>
              </div>
              <div className="col-md-4 m-2">
                <InputField
                  handleChange={(e) => {
                    setappointmentDetails({
                      ...appointmentDetails,
                      specialRequestFromTime: e.target.value,
                    })
                  }}
                  type="time"
                  value={appointmentDetails?.specialRequestFromTime} />
              </div>{" "}
            </div><div className="row doctor-details-item ">
                <div className="col-md-2">
                  <div className="doctor-details-text">Special Request To Time :</div>
                </div>
                <div className="col-md-4 m-2">
                  <InputField
                    handleChange={(e) => {
                      setappointmentDetails({
                        ...appointmentDetails,
                        specialRequestToTime: e.target.value,
                      })
                    }}
                    type="time"
                    value={appointmentDetails?.specialRequestToTime} />
                </div>{" "}
              </div></>
          }
          {isCheckedSpecial ? (
            ""
          ) : (
            <>
              <div className="row doctor-details-item">
                {selectedRadioBtn !== "IPD" && (
                  <>
                    <div className="col-md-2">
                      <div className="doctor-details-text col-4">
                        *Select Slot :{" "}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "1px solid #ccd0e7",
                            borderRadius: "10px"
                          })
                        }}
                        options={timeSlots}
                        defaultValue={selectedTime}
                        onChange={(option: any) => {
                          setselectedTime(option?.value)
                        }}
                        isSearchable={true}
                        placeholder="Select Slot"
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="row doctor-details-item">
                {selectedRadioBtn !== "IPD" && (
                  <>
                    <div className="col-md-2">
                      <div className="doctor-details-text">
                        Available Consultant Slot:
                      </div>
                    </div>
                    <div className="col-md-9 available-consultant-slots">
                      {timeSlot?.length > 0 ? (
                        <div className="consultant-text-values">
                          {/* -------------Slot timings ----- */}
                          {todayDate === modifiedDate ? (
                            <ul className="slot">{renderTodaySlots()}</ul>
                          ) : (
                            <ul className="slot">
                              {timeSlot.map((key: any) => renderEachTSlot(key))}
                            </ul>
                          )}
                          {/* ----------Radio button htmlFor Slot timmings ends------- */}
                        </div>
                      ) : (
                        <div
                          style={{
                            paddingLeft: "5px",
                            fontSize: "18px",
                            color: "red",
                            fontWeight: "800",
                          }}
                        >
                          {fieldsSelected ? "No Slots Available" : "Select Slots"}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </>
          )}
          <div className="row doctor-details-item ">
            <div className="col-md-2">
              <div className="doctor-details-text">Notes:</div>
            </div>
            <div className="col-md-4 my-2">
              <InputField
                handleChange={(e) => {
                  setappointmentDetails({
                    ...appointmentDetails,
                    comments: e.target.value,
                  })
                }}
                value={appointmentDetails?.comments}
              />
            </div>{" "}
          </div>{" "}
        </div>
        {isCheckedSpecial &&
          <div className="availability_for_day">
            <span className="avail_font">Availability for the Day
            </span>
            <h1 className="error">{`Morning:   ${availmor === undefined ? "Not Available" : availmor}`}</h1>
            <h1 className="error">{`Afternoon: ${availaftr === undefined ? "Not Available" : availaftr}`}</h1>
            <h1 className="error">{`Evening: ${availmoreve === undefined ? "Not Available" : availmoreve}`}</h1>
          </div>

        }
      </section>
    )
  }

  function renderSection5() {
    return (
      <div className="section-5-wrapper">
        <div className="doctor-details">
          <div className="row doctor-details-item">
            <div className="col-md-2">
              <div className="doctor-details-text">Select Preferred Room:</div>
            </div>
            <div className="col-md-4">
              <Select
                styles={customSelectStyles}
                options={room}
                defaultValue={preferedRoom?.id}
                onChange={(option: any) => {
                  const temp = allRooms?.find(
                    (each: any) => each?.id === option?.value
                  )
                  updatePreferedRoom(temp)
                  updatePreferedBed(
                    temp && temp?.bedDetails?.length > 1
                      ? ""
                      : temp?.bedDetails[0]?.id
                  )
                }}
                isSearchable={true}
                placeholder="Select Room"
              />
            </div>
          </div>
          {preferedRoom && preferedRoom?.bedDetails?.length > 1 && (
            <div className="row doctor-details-item">
              <div className="col-md-2">
                <div className="doctor-details-text">Select Preferred Bed:</div>
              </div>
              <div className="col-md-4">
                <Select
                  styles={customSelectStyles}
                  options={bed}
                  defaultValue={preferedRoom}
                  onChange={(option: any) => {
                    updatePreferedBed(option?.value)
                  }}
                  isSearchable={true}
                  placeholder="Select Bed"
                />
              </div>
            </div>
          )}
          <div className="row doctor-details-item">
            <div className="col-md-2">
              <div className="doctor-details-text">Select Preferred Time:</div>
            </div>
            <div className="col-md-4">
              <Select
                styles={customSelectStylesTest}
                options={pretime}
                defaultValue={selectedBedSlotTime}
                onChange={(option: any) => {
                  updateSelectedBedSlotTime(option?.value)
                }}
                isSearchable={true}
                placeholder="Select Preferred time"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  function renderSection6() {
    return (
      <>
        <section className="upload-documents">
          <div className="section-Heading" style={{ paddingBottom: "20px" }}>
            Upload Documents
          </div>
          <PedigreeView
            docs={appointmentDetails?.documents}
            patient={patient}
            type={"BookAppointment"}
            appointmentId={appointmentId}
            uploadDocument={(documents: any) => {
              setappointmentDetails({ ...appointmentDetails, documents })
            }}
          />
        </section>
      </>
    )
  }

  function renderSection7() {
    return (
      <section style={{ height: "100px" }}>
        <div className="section-wrapper">
          <div className="confirm-button">
            <Button
              outline={true}
              text="Cancel"
              type={"button"}
              onClick={() =>
                appointmentId
                  ? toggleDisplayToast({
                    text: `Clicking on back/close button will cancel the current appointment.\n Are you sure you want to continue?`,
                    onClickText: "Yes",
                    type: "warning",
                  })
                  : history.push(
                    userRole === MocUserRole.PATIENT
                      ? `/patientDetail`
                      : `/calendar`
                  )
              }
              id="book-appointment-cancel"
            />
            {isCheckedSpecial ? (
              <Button
                text="Special Appointment"
                onClick={confirmSpecialAppointment}
                id="special-appointment"
              />
            ) : userRole === MocUserRole.PATIENT ||
              userRole === MocUserRole.RMO ? (
              <Button
                text="Request  Appointment"
                onClick={confirmAppointment}
                id="confirm-appointment"
              />
            ) : (
              patient?.primaryConsultantName !== "" &&
              appointmentDetails?.appointmentType !== "" && (
                <Button
                  text="Confirm  Appointment"
                  onClick={confirmAppointment}
                  id="confirm-appointment"
                />
              )
            )}
          </div>
        </div>
      </section>
    )
  }


  useEffect(() => {
    if (element) {
      element?.scrollIntoView({ behavior: "smooth" })
    }
  }, [element])

  useEffect(() => {
    const centerId = userDetail?.currentCenter?.centerId
    if (centerId) {
      getDisabledCenters()
        .then((res: any) => {
          const disabledCenter = res?.disabledCenters?.find(
            (center: any) => center.id === centerId
          )
          if (disabledCenter) {
            setIsDisabledCenter(true)
            toggleDisplayToast({
              text: `${disabledCenter.name} has been disabled. Appointments cannot be booked.`,
              type: "error",
            })
          }
        })
        .catch((err) => {
          console.error("Error fetching disabled centers:", err)
        })
    }
  }, [userDetail?.currentCenter?.centerId])

  useEffect(() => {
    if (selectedRadioBtn === "HC") {
      getAllStaffs(
        `?centerId=${userDetail?.currentCenter?.centerId}&appointmentType=HC`
      ).then((res) => {
        setHomeCareConsultants(res)
        setDisplayConsultant(res)
      })
    } else {
      getAllConsultants(`/consultants?centerId=${userDetail?.currentCenter?.centerId}`)
        .then((res) => {
          setallConsultantDetails(res)
          setDisplayConsultant(res)
        })
        .catch((error) => {
          console.error("err", error)
        })
    }

    fetchRooms(userDetail?.currentCenter?.centerId)
      .then((res: any) => updateAllRooms(res))
      .catch((err: any) => console.error("err in room fetch", err))

    return () => {
      dispatch(drawerAction.setDrawerComponent(null))
    }
  }, [selectedRadioBtn])

  useEffect(() => {
    getServiceBasedOnCategory(selectedRadioBtn, userDetail?.currentCenter?.centerId)
      .then((res: any) => {
        if (res?.length === 0) {
          setserviceBasedCategory([0])
        } else {
          res?.map((val: any) => {
            return val.name
          })
          setserviceBasedCategory(res)
        }
      })
      .catch((error: any) => {
        console.error(error)
      })
  }, [selectedRadioBtn])

  useEffect(() => {
    if (selectedRadioBtn) {
      setDisplayConsultant(
        selectedRadioBtn === "HC" ? homecareConsultants : consultantDetails
      )
      setStartDate(
        userRole === MocUserRole.PATIENT && selectedRadioBtn === "IPD"
          ? moment().add(2, "d").toDate()
          : moment().toDate()
      )
    }
  }, [selectedRadioBtn])

  useEffect(() => {
    if (userRole === MocUserRole.PATIENT && userDetail?.id) {
      populatePatientDetail(userDetail?.id)
    }
  }, [userDetail])

  useEffect(() => {
    const patientid = new URLSearchParams(location.search).get("patientId")
    const appId = new URLSearchParams(location.search).get("appointmentId")

    updateAppointmentId(appId)

    if (appId) {
      fetchAppointmentById(appId)
    }

    if (patientid) {
      populatePatientDetail(patientid)
    }
  }, [location.search])

  useEffect(() => {
    let centerIdSpecial = userDetail?.currentCenter?.centerId
    if (consultantId !== undefined) {
      getAvailabilityDetails(
        centerIdSpecial,
        consultantId
      )
        .then((res) => {
          const filteredObj: any = {}
          const center = res[0]?.centerName
          filteredObj[center] = {}
          const today = new Date(startDate)
          const dayNumber = today.getDay()
          const daysOfWeek = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"]
          const day = daysOfWeek[dayNumber]
          Object.keys(res[0]?.availabilityTimeFrame)?.forEach((e) => {
            if (e?.toLowerCase()?.includes(day?.toLowerCase())) {
              if (e?.split("_")[1] === "MORNING") {
                setAvailMor(res[0]["availabilityTimeFrame"][`${e}`] ? res[0]["availabilityTimeFrame"][`${e}`] : "Not Available")
                filteredObj[center] = {
                  ...filteredObj[center],
                  "MORNING": res[0]["availabilityTimeFrame"][`${e}`] ? res[0]["availabilityTimeFrame"][`${e}`] : "Not Available",
                }
              } else if (e?.split("_")[1] === "AFTERNOON") {
                setAvailMorAftr(res[0]["availabilityTimeFrame"][`${e}`] ? res[0]["availabilityTimeFrame"][`${e}`] : "Not Available")
                filteredObj[center] = {
                  ...filteredObj[center],
                  "AFTERNOON": res[0]["availabilityTimeFrame"][`${e}`] ? res[0]["availabilityTimeFrame"][`${e}`] : "Not Available"
                }
              } else if (e?.split("_")[1] === "EVENING") {
                setAvailMorEve(res[0]["availabilityTimeFrame"][`${e}`] ? res[0]["availabilityTimeFrame"][`${e}`] : "Not Available")
                filteredObj[center] = {
                  ...filteredObj[center],
                  "EVENING": res[0]["availabilityTimeFrame"][`${e}`] ? res[0]["availabilityTimeFrame"][`${e}`] : "Not Available"
                }
              }
            }
          })
        })
        .catch((err) => {
          console.error("Err", err)
        })
    }
  }, [consultantId, startDate])

  useEffect(() => {
    const { consultantId, centerId, modifiedDate } = memoizedValues;

    if (consultantId && centerId && modifiedDate) {
      getAvailabilitySlots(consultantId, centerId, modifiedDate)
        .then((res) => {
          setAvaialbilitySlotsResult(res)
        })
        .catch((error) => {
          console.error('error time slots', error);
          setTimeSlot([]);
        });
    }
  }, [memoizedValues]);

  useEffect(() => {
    Object.keys(avaialbilitySlotsResult).forEach((key: any) => {
      if (key === selectedTime) {
        setTimeSlot(avaialbilitySlotsResult[key]);
      }
    });
  }, [selectedTime])

  useEffect(() => {
    const element = document.getElementById("appointment-wrapper")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }, [])

  // Use effect to trigger debounced API call on searchText or centerId change
  useEffect(() => {
    if (searchText && userDetail?.currentCenter?.centerId) {
      debouncedApiCall(searchText, userDetail.currentCenter.centerId);
    }

    // Cleanup debounce on unmount
    return () => {
      debouncedApiCall.cancel();
    };
  }, [searchText?.trim(), userDetail?.currentCenter?.centerId, debouncedApiCall]);

  useEffect(() => {
    // Check if all fields differ from their default values
    const { consultantId } = appointmentDetails;
    const allChanged =
      consultantId && selectedTime &&
      consultantId !== "" &&
      selectedTime !== "" && selectedTime.length > 0

    setFieldsSelected(allChanged)
  }, [appointmentDetails, selectedTime])

  useEffect(() => {
    let centerDetails = userDetail?.currentCenter?.centerId
    getCenterDetail(centerDetails).then((res) => {
      setSlotDurationTime(res?.slotDuration)
      setCenterReq(res?.ipdBookLimitDate)
    })
  }, [])

  return (
    <div id="appointment-wrapper" className="appointment-wrapper">
      <div className="content">
        {/* Section1 */}
        {renderSection1()}
        {/* section2 */}
        {renderSection2()}
        {/* Section 3 */}
        {renderSection3()}
        {/* Section 4 */}
        {renderSection4()}
        {/* Section5 */}
        {selectedRadioBtn === "IPD" && renderSection5()}
        {/* section6 */}
        {renderSection6()}
        {/* section7 */}
        {renderSection7()}
      </div>

      {displayToast ? (
        <Toast
          indexZ={true}
          textMessage={displayToast?.text}
          onClose={() => {
            toggleDisplayToast(false)
            if (isDisabledCenter) {
              history.push("/calendar")
              return
            }
            if (displayToast?.type === "success") {
              history.push(
                userRole === MocUserRole.PATIENT
                  ? `/patientDetail`
                  : `/calendar`
              )
            }
          }}
          onCloseText="Close"
          onClickText={
            displayToast?.onClickText ? displayToast?.onClickText : null
          }
          onClick={() => (displayToast?.onClickText ? history.goBack() : null)}
          type={displayToast?.type}
        />
      ) : isDead ? (
        <Toast
          indexZ={true}
          textMessage="Cannot book an appointment as the patient survival status is Deceased"
          onClose={() => {
            setIsDead(false)
            window.location.reload()
          }}
          onCloseText="Close"
          type="error"
        />
      ) : isInactive ? (
        <Toast
          indexZ={true}
          textMessage="Please mark the patient status as active and proceed to book an appointment"
          onClose={() => {
            setIsInactive(false)
            window.location.reload()
          }}
          onCloseText="Close"
          type="warning"
        />
      ) : (
        ""
      )}
    </div>
  )
}

export default BookAppointments
